export default {
  where: '',
  whereType: 'SearchTerm',
  when: '',
  how: '',
  departure: '',
  autoCompleteUrl: '/umbraco/api/search/Suggest',
  suggestions: [],
  departures: [],
  dates: [],
  types: []
};